module.exports = __webpack_public_path__ + "static/media/24.8e124228.jpg";